import CustomSelect from '../../../Forms/Element/CustomSelect';
import Api from '../../../../../constants/Api';
import axiosInstance from '../../../../../services/AxiosInstance';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const DreGroupSelect = ({ ...props }) => {

    const { t } = useTranslation();
    const [entities, setEntities] = useState([]);

    useEffect(() => {

        function findAll() {
            setEntities([]);

            axiosInstance.get(Api.cash_flow.category + "/dre-groups")
                .then(response => {
                    let entities = [];

                    for (var i = 0; i < response.data.length; i++) {
                        entities.push(
                            {
                                value: response.data[i].value,
                                label: response.data[i].name
                            }
                        );

                        setEntities(entities);
                    }
                });
        }

        findAll();
    }, []);

    return (
        <CustomSelect options={entities} value={props.value} onChange={props.onChange} isClearable placeholder={t("select")} isDisabled={props.isDisabled} error={props.error} />
    )
};

export default DreGroupSelect;